import { createFileRoute } from '@tanstack/react-router'
import { ComponentDemos } from './-components/dev-resources/component-demos'
import { ComponentsPending } from './-components/dev-resources/dev-resources-pending'

export const Route = createFileRoute('/_app/dev-resources/components')({
  component: ComponentDemos,
  pendingComponent: ComponentsPending,
})
